import { render, staticRenderFns } from "./DisclosedReport.vue?vue&type=template&id=45927e0e&scoped=true"
import script from "./DisclosedReport.vue?vue&type=script&lang=js"
export * from "./DisclosedReport.vue?vue&type=script&lang=js"
import style0 from "./DisclosedReport.vue?vue&type=style&index=0&id=45927e0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45927e0e",
  null
  
)

export default component.exports